import { ICommunicationPreferences } from '../../interfaces/HotelReservationV2/ICommunicationPreferences';
import { useDefault } from '../../../common/common';
import { CommunicationPreferences } from '../../model/communication/communication.preferences.model';

export class CommunicationPreferencesRequestBuilder {
    private _request: any;

    constructor () {
        this._request = {};
        this._request.communicationPreferences =  <ICommunicationPreferences>{};
    }

    withCommunicationPreferences(commPrefs: CommunicationPreferences) {
        const communicationPreferences = useDefault(commPrefs, new CommunicationPreferences());
        this._request.communicationPreferences = <ICommunicationPreferences>{emailAddresses: [communicationPreferences.emailAddress], sendEmail: communicationPreferences.sendEmail, smsNumbers: [communicationPreferences.smsNumber], sendSMS: communicationPreferences.sendSMS, faxNumbers: [communicationPreferences.faxNumber]};
        return this;
      }

    build (): ICommunicationPreferences {
        return this._request;
    }
} 


// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/builders/communication-preferences-request.builder.ts